/**
 * Pool-scoped slice of the global event stream.
 *
 * Locked to this pool's id (and its parent service for completeness
 * — every pool event already carries `pool_id`, but keeping the
 * service filter in the chain matches what the events router sees
 * for the equivalent Global Events deep-link URL).
 */
import { EventsStream } from "@/components/EventsStream";
import type { Pool, Service } from "@/api/types";

interface Props {
  pool: Pool;
  service: Service;
}

export function PoolEvents({ pool, service }: Props) {
  return (
    <EventsStream
      lockedScope={{ service_id: service.id, pool_id: pool.id }}
    />
  );
}
